export const formatClock = (exact: string | null, category: string) => {
  if (!exact) return category;
  const [baseToken, incrementToken] = exact.split("+");
  const base = Number(baseToken);
  const increment = Number(incrementToken ?? 0);
  if (!Number.isFinite(base)) return exact;
  const baseLabel = base >= 60 && base % 60 === 0 ? `${base / 60} min` : `${base} sec`;
  return increment > 0 ? `${baseLabel} + ${increment} sec` : baseLabel;
};

export const formatDuration = (seconds: number | null) => {
  if (seconds == null) return "—";
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
};

export const formatPlayedAt = (value: string) =>
  new Intl.DateTimeFormat("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));

export const titleCase = (value: string) => value.replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
